import { Link } from 'react-router-dom';

interface GameCardProps {
  slug: string;
  title: string;
  category: string;
  rating: number;
  image: string;
  rank?: number;
}

export default function GameCard({ slug, title, category, rating, image, rank }: GameCardProps) {
  const stars = Math.round(rating);
  const categoryNames: Record<string, string> = {
    rpg: 'RPG',
    avg: 'AVG',
    slg: 'SLG',
    act: 'ACT',
    puzzle: 'Puzzle',
    sandbox: 'Sandbox',
    simulation: 'Simulation',
    doujin: 'Doujin',
  };

  return (
    <Link
      to={`/article/${slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {rank && (
            <span className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold">
              {rank}
            </span>
          )}
          <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-950/70 backdrop-blur-sm rounded-full px-2 py-0.5">
            <i className="ri-star-fill text-accent-400 text-xs"></i>
            <span className="text-background-50 text-xs font-medium">{rating}</span>
          </div>
        </div>
        <div className="p-3">
          <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
            {title}
          </h3>
          <span className="inline-block mt-1.5 text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">
            {categoryNames[category] || category}
          </span>
        </div>
      </div>
    </Link>
  );
}